<script lang="ts">
import { range } from "rxjs";


import { onDestroy } from "svelte";
import { TIME_LIMIT_MINUTES } from "../evironment";
import type { Zone } from "../Model/Zone";
import { zonesService } from "../services";
import ScheduleText from "./ScheduleText.svelte";

    onDestroy(
        () => {
            window.clearInterval(clockInterval);
        }
    )

    export let parkTime: Date;
    export let zoneId;
    let clockInterval: number;
    let zone: Zone;
    let timeToEnd = '00:00';

    $: chrono(parkTime);
    
    async function chrono(parkTime) {   

        let zoneTime = TIME_LIMIT_MINUTES;

        if (zoneId) {
            zone = await zonesService.getZone(zoneId); 
            if (zone.time) {
                zoneTime = zone.time;
            }           
        }
        
        clockInterval = window.setInterval(function (){  
            
            timeToEnd = '00:00'
        
            const parkingTime = new Date(parkTime);

            const date = parkingTime.getDay();
            const zoneDate = zone.schedule.find(z => z.index == date);
            const ranges = zoneDate.ranges

            const timeText = createTextDate(new Date());
            
            const timeIsRange = ranges.some(r => {
                if (r.from < timeText && r.until > timeText && r.enabled) {
                    return true;
                }
            })

            if (!timeIsRange) {
                const parkingTimeGetTime = createTextDate(parkingTime);

                const rangeSelectPass = ranges.some(r => r.until > parkingTimeGetTime && r.enabled);

                timeToEnd = zone.time + ':00'; 
           
            }else{

                const rangeSelect = ranges.find(r => r.from < timeText && r.until > timeText && r.enabled);

                const parkingTimeGetTime = createTextDate(parkingTime);
                const parkingRangeGetTime = rangeSelect.from;

                const parkingTimeSelect = parkingRangeGetTime > parkingTimeGetTime ? 
                                    parkingRangeGetTime :  parkingTimeGetTime;

                const [hours, minutesTime] = parkingTimeSelect.split(':').map(n => parseInt(n))

                const iniTime = new Date();
                
                parkingTime.setHours(hours);
                parkingTime.setMinutes(minutesTime);

                const endTime = new Date(parkingTime.getTime() + zoneTime*60000);
                
                // const parkingTimeEndGetTime = createTextDate(endTime);

                let diff = endTime.getTime() - iniTime.getTime();

                let minutes: number = Math.floor(diff / 60000);

                if (minutes < 0) {
                    window.clearInterval(clockInterval);
                }else{
                    timeToEnd = createTextDiff(diff);
                }
            }
        }, 1000);
    } 

    function createTextDiff(diff: number){
        const minutes: number = Math.floor(diff / 60000);
        const seconds: number = parseInt(((diff % 60000) / 1000).toFixed(0));

        return (minutes < 10 ? '0' : '') + minutes + ":" + (seconds < 10 ? '0' : '') + seconds
    }

    function createTextDate(dateToCreated: Date){
        const hours = dateToCreated.getHours();
        const minutes = dateToCreated.getMinutes();

        return (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes;
    }
        

</script>

<span class="number-time">
    {timeToEnd}
</span>


